<template>
  <div class="list-container" :class="{ 'form-fullScreen': isEdit }">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <div class="filter-box">
          <span class="label">联系人姓名</span>
          <el-input
            v-model="listQuery.name"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">联系人手机</span>
          <el-input
            v-model="listQuery.phone"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>

        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
        </div>
      </div>
      <TableList
        ref="TableList"
        v-loading="listLoading"
        :dataList="list"
        :total="total"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :showSelection="false"
        :canRefresh="false"
        :canChangeColumn="false"
        :handleDefaultWidth="120"
        :maxHight="224"
        :canCommand="canCommand"
        @command-change="handleCommand"
      >
        <template v-slot:name="scope">
          <svg
            class="icon"
            aria-hidden="true"
            font-size="20px"
            v-if="scope.row.showBirthday"
          >
            <use xlink:href="#icon-tubiao-21" />
          </svg>
          <span>{{scope.row.name}} </span>
        </template>
        <template v-slot:defaultValue="scope">
          <span>{{scope.row.defaultValue ? '是' : '否'}} </span>
        </template>

        <template v-slot:operation-action="scope">
          <CommandRender
            :scopeRow='scope.row'
            :codeList="btnList"
            :permissionName="permissionName"
            @command-change="handleCommand"
          />
        </template>
      </TableList>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :submitParams="{ customerCompanyId: id }"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :handleResolveTempData="handleResolveTempData"
      :api="'customerCompanyContact'"
      @update:visibel="dialogFormVisible = false;isEdit = false"
      @submit="handleSubmit(formData);isEdit = false"
    />
    <el-dialog
      v-model="viewPayVisible"
      title="查看付款信息"
      width="50%"
    >
      <ViewPay :contactId="activeId" v-if="viewPayVisible" @update:visible="viewPayVisible = false"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" @click="viewPayVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="setEnableVisible"
      title="启用"
      width="50%"
    >
      <div >
        <el-form ref="setForm" :model="setEnableForm" label-width="100px" label-position="top" :rules="setEnableRules">
          <el-form-item label="费用税率" prop="rate" >
            <el-input v-model="setEnableForm.rate" clearable />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="setEnableVisible = false" type="danger">取消</el-button>
          <el-button type="primary" @click="handleSetEnable" :loading="submitLoading">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, watch, unref, nextTick } from 'vue'
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getCompanyContactById, deleteCompanyContactById, getCompanyContactList, setDefaultContact, deleteAtionsMarket, setAtionsMarket } from '@/apis/CustomerCompanyContact'
import { getDropdown } from '@/apis/Dictionary'
import { getDropdownByType } from '@/apis/tool'
import { salesmanUser } from '@/apis/user'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'
import ViewPay from '../viewPay/Index.vue'
import CommandRender from '@/components/common/CommandRender.vue'
import { pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Concat',
  components: {
    FormComponent,
    TableList,
    ViewPay,
    CommandRender
  },
  props: {
    id: { type: Number, required: true, default: 0 },
    canCommand: { type: Boolean, required: false, default: true }
  },
  setup(props) {
    const { t } = useI18n()
    const TableList = ref(null)
    const setForm = ref(ElForm)

    const dataMap = reactive({
      TableName: TableName.TABLE_CUSTOMERCONTACT,
      permissionName: permissionName.CUSTOMER_CONTACT,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        phone: undefined,
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,
      salesManOption: [],
      setEnableVisible: false,
      setEnableForm: {
        taxType: ''
      },
      setEnableRules: {
        rate: [{ required: true, message: '请填写必填项', trigger: ['change', 'blur'] }]
      },
      submitLoading: false,
      viewPayVisible: false,
      isEdit: false,
      btnList: [] as any,

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            dataMap.isEdit = true
            break
          case 'edit':

            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            ;(TableList.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'enable':
            dataMap.activeId = val.id
            dataMap.setEnableVisible = true
            break
          case 'disable':
            dataMap.handleDisable(val)
            break
          case 'viewPay':
            dataMap.activeId = val.id
            dataMap.viewPayVisible = true
            break
          case 'setDefaul':
            dataMap.handleSetDefault(val)
            break
        }
      },
      getList() {
        if (!props.id) {
          dataMap.list = []
          return
        }
        dataMap.listLoading = true
        getCompanyContactList(Object.assign(dataMap.listQuery, { customerCompanyId: props.id })).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          phone: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getCompanyContactById(row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = res[field.fieldKey] || field.value
                switch (field.fieldKey) {
                  case 'address':
                    field.value = res.livePlace ? res.livePlace.split('-') : ''
                    break
                }
              })
            } else if (k.type === 2 && res.accounts) {
              const _arr = [] as ArrayRowsItem
              const addContions = dataMap.initFormData.find((j: any) => j.title === '账户信息')?.formList
              if (addContions) {
                const accounts = JSON.parse(res.accounts)
                accounts.forEach((item: any) => {
                  const _copyContion = cloneDeep(addContions)[0]
                  _copyContion.id = item.id
                  Object.keys(item).forEach(k => {
                    _copyContion.list?.forEach((j: any) => {
                      if (j.fieldKey === k) {
                        j.value = item[k] || j.value
                      }
                    })
                  })
                  _arr.push(_copyContion)
                })
                k.formList = _arr
              }
            }
          })
          dataMap.dialogFormVisible = true
          dataMap.isEdit = true
        })
      },
      handleResolveTempData(tempModel: any) {
        const { address } = tempModel
        let contacts = tempModel.contacts
        if (contacts) {
          contacts.map((k: any) => {
            k.address = address ? address.join('-') : ''
            return {
              ...k
            }
          })
        } else {
          contacts = []
        }
        tempModel.address = address ? address.join('-') : ''
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteCompanyContactById(row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleDisable(row: any) {
        ElMessageBox.confirm(
          '确定要禁用改市场人员吗？',
          '禁用',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteAtionsMarket(row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '禁用成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSetDefault(row: any) {
        ElMessageBox.confirm(
          '确定设置选中数据为默认联系人吗？',
          '提示',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        ).then(() => {
          setDefaultContact(row.id).then(() => {
            dataMap.getList()
            ElMessage({
              message: '设置成功',
              type: 'success',
              duration: 1000
            })
          })
        })
      },
      handleSetEnable() {
        const SetForm = unref(setForm)
        SetForm.validate((valid: any) => {
          if (valid) {
            dataMap.submitLoading = true
            setAtionsMarket(dataMap.activeId, dataMap.setEnableForm).then(() => {
              ElMessage({
                message: '启用成功',
                type: 'success',
                duration: 1000
              })
              dataMap.getList()
              dataMap.setEnableForm = {
                taxType: ''
              }
              dataMap.setEnableVisible = false
              dataMap.submitLoading = false
            }).catch((err: any) => {
              dataMap.submitLoading = false
              err.errors && err.errors.forEach((item: any) => {
                dataMap.setEnableRules[item.field][0].message = null
                nextTick(() => {
                  dataMap.setEnableRules[item.field][0].message = item.defaultMessage
                })
              })
            })
          }
        })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      getDropdownByType() {
        getDropdownByType('ReviewStatus').then((res: any) => {
          dataMap[`${'ReviewStatus'}Option`] = res
        })
      },
      loadSalesMan() {
        salesmanUser().then((res: any) => {
          dataMap.salesManOption = res
        })
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 2 && column.url) {
            getDropdown(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          } else if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      }
    })

    watch(() => props.id, () => {
      dataMap.getList()
    })

    onMounted(async() => {
      await dataMap.loadTableSelectOption()
      dataMap.getList()
      dataMap.loadDropdownList('customerLevel')
      dataMap.loadDropdownList('customerSource')
      dataMap.loadDropdownList('paymentCycle')
      dataMap.getDropdownByType()
      dataMap.btnList = [
        {
          pkey: `${dataMap.permissionName}_EDIT`,
          name: '编辑',
          command: 'edit'
        }, {
          pkey: `${dataMap.permissionName}_ENABLE`,
          name: '启用市场人员',
          command: 'enable',
          visible: (row: any) => {
            return !row.marketFlag
          }
        }, {
          pkey: `${dataMap.permissionName}_DISABLE`,
          name: '禁用市场人员',
          command: 'disable',
          visible: (row: any) => {
            return row.marketFlag
          }
        }, {
          pkey: `${dataMap.permissionName}_SET_DEFAULT`,
          name: '设置默认开票资料',
          command: 'setDefaul',
          visible: (row: any) => {
            return !row.defaultValue
          }
        }, {
          pkey: `${dataMap.permissionName}_DELETE`,
          name: '删除',
          type: 'danger',
          command: 'delete'
        }
      ]
    })
    return { TableList, t, ...toRefs(dataMap), setForm }
  }
})
</script>
<style  lang="scss">
</style>
